import { useRouter } from 'next/router'
import { useCallback } from 'react'

import { SSOLoginPage } from '~/components/SSOLoginPage'
import { SsoIdentityProvider } from '~/graphql/generated/query.types'

const SSOSamlPage = () => {
  const router = useRouter()

  const ssoIdentityProvider = router.query.ssoIdentityProvider as SsoIdentityProvider
  const email = router.query.email as string
  const samlLoginUrl = router.query.samlLoginUrl as string

  const handleSSOLogin = useCallback(() => {
    if (samlLoginUrl) {
      window.location.href = samlLoginUrl
    }
  }, [samlLoginUrl])

  return (
    <SSOLoginPage
      email={email}
      ssoIdentityProvider={ssoIdentityProvider}
      onLogin={handleSSOLogin}
    />
  )
}

export default SSOSamlPage
